class HomeCtrl {
    constructor($scope, $location, storeServ, shopTypesServ) {
        this.$scope = $scope;
        this.$location = $location;
        this.storeServ = storeServ;
        this.shopTypesServ = shopTypesServ;
        this.geolocateOnMapReady = this.$location.search().pos ? false : true;
        this.storeServ.dispatch({
            type: 'SET_SHOP_TYPE',
            shopType: {
                context: this.shopTypesServ.getContextShops(),
                typeFilters: [],
                subTypeFilters: []
            }
        });

        this.$scope.$on('$destroy', this.onDestroyComponent.bind(this));
    }

    onDestroyComponent() {
        this.storeServ.getState().shopType && this.storeServ.dispatch({
            type: 'SET_SHOP_TYPE',
            shopType: {
                context: '',
                typeFilters: [],
                subTypeFilters: []
            }
        });
    }
}

HomeCtrl.$inject = ['$scope', '$location', 'storeServ', 'shopTypesServ'];

export default HomeCtrl;